var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-home"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.76.886l27.825 32.463a1 1 0 01-.76 1.651H50a1 1 0 00-1 1v23a1 1 0 01-1 1H35a1 1 0 01-1-1V46a1 1 0 00-1-1h-8a1 1 0 00-1 1v13a1 1 0 01-1 1H10a1 1 0 01-1-1V36a1 1 0 00-1-1H1.174a1 1 0 01-.759-1.65L28.241.885a1 1 0 011.518 0z",
    className: "fill-current",
    fillRule: "evenodd"
  })));
}
export default SvgHome;